<app-auth-page-layout>
  <div class="flex flex-col flex-1 w-full lg:w-1/2">
    <div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto px-6 py-10">

      <div class="mb-5 sm:mb-8">
        <a routerLink="/signin"
          class="inline-flex items-center mb-4 text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" class="size-5">
            <path d="M12.7083 5L7.5 10.2083L12.7083 15.4167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          Volver a iniciar sesión
        </a>
        <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
          {{ mode === 'reset' ? 'Nueva contraseña' : 'Recuperar contraseña' }}
        </h1>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          @if (mode === 'reset') {
            Ingresa tu nueva contraseña para completar el restablecimiento.
          } @else {
            Ingresa tu correo y te enviaremos instrucciones para restablecer tu contraseña.
          }
        </p>
      </div>

      <!-- Error alert (común a ambos modos) -->
      @if (error) {
        <div class="flex items-center gap-3 px-4 py-3 mb-5 text-sm rounded-lg bg-error-50 text-error-700 dark:bg-error-500/10 dark:text-error-400">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
          {{ error }}
        </div>
      }

      <!-- ============ MODO SOLICITAR ============ -->
      @if (mode === 'request') {
        @if (requestSent) {
          <div class="flex flex-col items-center justify-center gap-6 py-6 text-center">
            <div class="flex items-center justify-center w-16 h-16 rounded-full bg-success-50 dark:bg-success-500/10">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-success-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <p class="text-sm text-gray-600 dark:text-gray-300">{{ requestMessage }}</p>
            <a routerLink="/signin"
              class="inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 transition-colors">
              Volver a iniciar sesión
            </a>
          </div>
        } @else {
          <form (ngSubmit)="onRequest()" class="space-y-5">
            <div>
              <app-label>Correo electrónico <span class="text-error-500">*</span></app-label>
              <app-input-field
                type="email"
                name="email"
                placeholder="correo@ejemplo.com"
                [value]="email"
                (valueChange)="email = $event.toString(); onFieldChange()"
              />
              @if (emailError) {
                <p class="mt-1.5 text-sm text-error-500">{{ emailError }}</p>
              }
            </div>
            <button
              type="submit"
              [disabled]="submitting || !email"
              class="flex items-center justify-center w-full gap-2 px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-brand-500 shadow-theme-xs hover:bg-brand-600 disabled:opacity-60 disabled:cursor-not-allowed">
              @if (submitting) {
                <span class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                Enviando...
              } @else {
                Enviar instrucciones
              }
            </button>
          </form>
        }
      }

      <!-- ============ MODO RESTABLECER ============ -->
      @if (mode === 'reset') {
        @if (resetDone) {
          <div class="flex flex-col items-center justify-center gap-6 py-6 text-center">
            <div class="flex items-center justify-center w-16 h-16 rounded-full bg-success-50 dark:bg-success-500/10">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-success-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div>
              <h2 class="mb-2 text-lg font-semibold text-gray-800 dark:text-white/90">¡Contraseña actualizada!</h2>
              <p class="text-sm text-gray-500 dark:text-gray-400">Redirigiendo al inicio de sesión...</p>
            </div>
          </div>
        } @else {
          <form (ngSubmit)="onReset()" class="space-y-5">
            <div>
              <app-label>Nueva contraseña <span class="text-error-500">*</span></app-label>
              <div class="relative">
                <app-input-field
                  [type]="showPassword ? 'text' : 'password'"
                  name="newPassword"
                  autocomplete="new-password"
                  placeholder="Mínimo 8 caracteres"
                  [value]="newPassword"
                  (valueChange)="newPassword = $event.toString(); onFieldChange()"
                />
                <span (click)="togglePasswordVisibility()"
                  class="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2">
                  @if (showPassword) {
                    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-gray-500 dark:fill-gray-400 size-5">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 13.8619C7.23361 13.8619 4.86803 12.1372 3.92328 9.70241C4.86804 7.26761 7.23361 5.54297 10.0002 5.54297C12.7667 5.54297 15.1323 7.26762 16.0771 9.70243C15.1323 12.1372 12.7667 13.8619 10.0002 13.8619ZM10.0002 4.04297C6.48191 4.04297 3.49489 6.30917 2.4155 9.4593C2.3615 9.61687 2.3615 9.78794 2.41549 9.94552C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C13.5184 15.3619 16.5055 13.0957 17.5849 9.94555C17.6389 9.78797 17.6389 9.6169 17.5849 9.45932C16.5055 6.30919 13.5184 4.04297 10.0002 4.04297ZM9.99151 7.84413C8.96527 7.84413 8.13333 8.67606 8.13333 9.70231C8.13333 10.7286 8.96527 11.5605 9.99151 11.5605H10.0064C11.0326 11.5605 11.8646 10.7286 11.8646 9.70231C11.8646 8.67606 11.0326 7.84413 10.0064 7.84413H9.99151Z"></path>
                    </svg>
                  } @else {
                    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-gray-500 dark:fill-gray-400 size-5">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.63803 3.57709C4.34513 3.2842 3.87026 3.2842 3.57737 3.57709C3.28447 3.86999 3.28447 4.34486 3.57737 4.63775L4.85323 5.91362C3.74609 6.84199 2.89363 8.06395 2.4155 9.45936C2.3615 9.61694 2.3615 9.78801 2.41549 9.94558C3.49488 13.0957 6.48191 15.3619 10.0002 15.3619C11.255 15.3619 12.4422 15.0737 13.4994 14.5598L15.3625 16.4229C15.6554 16.7158 16.1302 16.7158 16.4231 16.4229C16.716 16.13 16.716 15.6551 16.4231 15.3622L4.63803 3.57709ZM12.3608 13.4212L10.4475 11.5079C10.3061 11.5423 10.1584 11.5606 10.0064 11.5606H9.99151C8.96527 11.5606 8.13333 10.7286 8.13333 9.70237C8.13333 9.5461 8.15262 9.39434 8.18895 9.24933L5.91885 6.97923C5.03505 7.69015 4.34057 8.62704 3.92328 9.70247C4.86803 12.1373 7.23361 13.8619 10.0002 13.8619C10.8326 13.8619 11.6287 13.7058 12.3608 13.4212ZM16.0771 9.70249C15.7843 10.4569 15.3552 11.1432 14.8199 11.7311L15.8813 12.7925C16.6329 11.9813 17.2187 11.0143 17.5849 9.94561C17.6389 9.78803 17.6389 9.61696 17.5849 9.45938C16.5055 6.30925 13.5184 4.04303 10.0002 4.04303C9.13525 4.04303 8.30244 4.17999 7.52218 4.43338L8.75139 5.66259C9.1556 5.58413 9.57311 5.54303 10.0002 5.54303C12.7667 5.54303 15.1323 7.26768 16.0771 9.70249Z"></path>
                    </svg>
                  }
                </span>
              </div>
            </div>

            <div>
              <app-label>Confirmar contraseña <span class="text-error-500">*</span></app-label>
              <app-input-field
                [type]="showPassword ? 'text' : 'password'"
                name="confirmPassword"
                autocomplete="new-password"
                placeholder="Repite la contraseña"
                [value]="confirmPassword"
                (valueChange)="confirmPassword = $event.toString(); onFieldChange()"
              />
            </div>

            <button
              type="submit"
              [disabled]="submitting || !newPassword || !confirmPassword"
              class="flex items-center justify-center w-full gap-2 px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-brand-500 shadow-theme-xs hover:bg-brand-600 disabled:opacity-60 disabled:cursor-not-allowed">
              @if (submitting) {
                <span class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                Guardando...
              } @else {
                Restablecer contraseña
              }
            </button>
          </form>
        }
      }

    </div>
  </div>
</app-auth-page-layout>
